// ÐÐ¸Ð´Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð², ÐºÐ¾ÑÐ¾ÑÑÐµ ÐºÐ»Ð¸ÐµÐ½Ñ Ð³ÑÑÐ·Ð¸Ñ ÑÐ°Ð¼. ÐÐ»ÑÑÐ¸ ÑÐ¾Ð²Ð¿Ð°Ð´Ð°ÑÑ Ñ Ð¿Ð¾Ð»ÑÐ¼Ð¸
// Ð°Ð½ÐºÐµÑÑ (createCreditAppeal) Ð¸ Ñ Ð²Ð¸Ð´Ð°Ð¼Ð¸ Ð½Ð° Ð±ÑÐºÐµ (ClientUploadRules).
export const CLIENT_UPLOAD_KINDS = {
  incomeCertificate: {
    title: 'Ð¡Ð¿ÑÐ°Ð²ÐºÐ° / Ð²ÑÐ¿Ð¸ÑÐºÐ° Ð¾ Ð´Ð¾ÑÐ¾Ð´Ð°Ñ',
    managerTitle: 'Ð¡Ð¿ÑÐ°Ð²ÐºÐ° / Ð²ÑÐ¿Ð¸ÑÐºÐ° Ð¾ Ð´Ð¾ÑÐ¾Ð´Ð°Ñ',
    hint: 'PDF Ð¸Ð»Ð¸ ÑÐ¾ÑÐ¾ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
    photo: false,
  },
  workCertificate: {
    title: 'ÐÑÐ¿Ð¸ÑÐºÐ° ÑÐ¾ ÑÑÑÑÐ°',
    managerTitle: 'ÐÑÐ¿Ð¸ÑÐºÐ° ÑÐ¾ ÑÑÑÑÐ°',
    hint: 'PDF Ð¸Ð»Ð¸ ÑÐ¾ÑÐ¾ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
    photo: false,
  },
  clientPhoto: {
    title: 'ÐÐ°ÑÐµ ÑÐ¾ÑÐ¾',
    managerTitle: 'Ð¤Ð¾ÑÐ¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
    hint: 'ÐÐ¸ÑÐ¾ ÑÐ¾ÑÐ¾ÑÐ¾ Ð²Ð¸Ð´Ð½Ð¾, Ð±ÐµÐ· Ð¾ÑÐºÐ¾Ð² Ð¸ Ð³Ð¾Ð»Ð¾Ð²Ð½Ð¾Ð³Ð¾ ÑÐ±Ð¾ÑÐ°',
    photo: true,
  },
};

// ÐÐ¾ÑÑÐ´Ð¾Ðº ÑÐ¾Ð²Ð¿Ð°Ð´Ð°ÐµÑ Ñ Ð±ÑÐºÐ¾Ð¼ (ClientUploadRules.Kinds).
export const ALL_KINDS = ['incomeCertificate', 'workCertificate', 'clientPhoto'];

// Ð§ÑÐ¾ Ð¼Ð¾Ð¶Ð½Ð¾ Ð·Ð°Ð¿ÑÐ¾ÑÐ¸ÑÑ Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¿ÑÐ¸ ÐµÐ³Ð¾ ÑÑÐ°ÑÑÑÐµ: ÑÐ¾ÑÐ¾ â Ð²ÑÐµÐ³Ð´Ð°, ÑÐ¿ÑÐ°Ð²ÐºÑ Ð¾ Ð´Ð¾ÑÐ¾Ð´Ð°Ñ Ð¸ Ð²ÑÐ¿Ð¸ÑÐºÑ ÑÐ¾ ÑÑÑÑÐ° â ÑÐ¾Ð»ÑÐºÐ¾
// ÑÐ°Ð¼, Ð³Ð´Ðµ Ð°Ð½ÐºÐµÑÐ° Ð¸Ñ ÑÑÐµÐ±ÑÐµÑ (ÑÐµ Ð¶Ðµ ÑÑÐ»Ð¾Ð²Ð¸Ñ, ÑÑÐ¾ Ñ Ð¿Ð¾Ð»ÐµÐ¹ Â«Ð¡ÐºÐ°Ð½Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²Â»). ÐÑÑÐ°Ð»ÑÐ½Ð¾Ðµ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¼ÐµÑÐ°Ð»Ð¾.
export const availableKinds = ({ showIncome, showWork }) =>
  ALL_KINDS.filter((kind) => (kind === 'incomeCertificate' ? !!showIncome : kind === 'workCertificate' ? !!showWork : true));

// Ð§ÑÐ¾ Ð¾ÑÐ¼ÐµÑÐ¸ÑÑ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ: Ð¿Ð¾ ÑÑÐ»Ð¾Ð²Ð¸ÑÐ¼ Ð°Ð½ÐºÐµÑÑ, Ð±ÐµÐ· ÑÐ¶Ðµ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð½Ð¾Ð³Ð¾. ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ
// Ð¼Ð¾Ð¶ÐµÑ Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑ Ð²ÑÐ±Ð¾Ñ â Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ, Ð·Ð°Ð¿ÑÐ¾ÑÐ¸ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð²ÑÐ¿Ð¸ÑÐºÑ.
export const defaultKinds = ({ showIncome, showWork, received }) =>
  [
    ...(showIncome ? ['incomeCertificate'] : []),
    ...(showWork ? ['workCertificate'] : []),
    'clientPhoto',
  ].filter((kind) => !received?.[kind]);

// Ð¡Ð¿Ð¸ÑÐ¾Ðº ÑÐ°Ð¹Ð»Ð¾Ð² ÑÑÐ°ÑÑÑÐ° â { Ð²Ð¸Ð´: ÑÐ°Ð¹Ð» }.
export const receivedByKind = (files) =>
  (files || []).reduce((acc, f) => ({ ...acc, [f.kind]: f }), {});

// ÐÐ¾Ð»Ðµ Ð°Ð½ÐºÐµÑÑ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¾, ÐµÑÐ»Ð¸ ÑÐ°Ð¹Ð» Ð¿ÑÐ¸Ð»Ð¾Ð¶Ð¸Ð» Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¸Ð»Ð¸ Ð¿ÑÐ¸ÑÐ»Ð°Ð» ÐºÐ»Ð¸ÐµÐ½Ñ.
export const hasDocument = (files, received, kind) => !!(files?.[kind] || received?.[kind]);

// Ð Ð°Ð·Ð¼ÐµÑ Ð¿Ð¾ÑÐ»Ðµ ÑÐ¼ÐµÐ½ÑÑÐµÐ½Ð¸Ñ: Ð´Ð»Ð¸Ð½Ð½Ð°Ñ ÑÑÐ¾ÑÐ¾Ð½Ð° Ð½Ðµ Ð±Ð¾Ð»ÑÑÐµ max, Ð¿ÑÐ¾Ð¿Ð¾ÑÑÐ¸Ð¸ ÑÐµ Ð¶Ðµ.
// Ð¤Ð¾ÑÐ¾ Ñ ÑÐ¾Ð²ÑÐµÐ¼ÐµÐ½Ð½Ð¾Ð³Ð¾ ÑÐµÐ»ÐµÑÐ¾Ð½Ð° Ð±ÑÐ²Ð°ÐµÑ 10+ ÐÐ â Ð½Ð° Ð¼Ð¾Ð±Ð¸Ð»ÑÐ½Ð¾Ð¼ Ð¸Ð½ÑÐµÑÐ½ÐµÑÐµ ÑÑÐ¾
// Ð´Ð¾Ð»Ð³Ð¾, Ð° Ð´Ð»Ñ Ð±Ð°Ð½ÐºÐ¾Ð² ÑÐ²Ð°ÑÐ°ÐµÑ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð¸Ñ ÑÐºÐ°Ð½Ð°.
export const fitSize = (width, height, max) => {
  const longest = Math.max(width, height);
  if (longest <= max) return { width, height };
  const k = max / longest;
  return { width: Math.round(width * k), height: Math.round(height * k) };
};

export const MAX_IMAGE_SIDE = 2400;

// Ð£Ð¼ÐµÐ½ÑÑÐ°ÐµÑ ÐºÐ°ÑÑÐ¸Ð½ÐºÑ Ð² Ð±ÑÐ°ÑÐ·ÐµÑÐµ; PDF Ð¸ Ð»ÑÐ±ÑÐµ Ð½ÐµÑÐ´Ð°ÑÐ¸ Ð¾ÑÐ´Ð°ÑÑ ÐºÐ°Ðº ÐµÑÑÑ.
export const shrinkImage = (file) => {
  if (!file || !/^image\/(jpeg|png|webp|heic|heif)$/i.test(file.type || '')) return Promise.resolve(file);
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      try {
        const { width, height } = fitSize(img.naturalWidth, img.naturalHeight, MAX_IMAGE_SIDE);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            URL.revokeObjectURL(url);
            // ÐÑÑÐ¾ÑÐ»Ð¾ Ð¸Ð»Ð¸ Ð½Ðµ Ð¿Ð¾Ð»ÑÑÐ¸Ð»Ð¾ÑÑ â Ð¾ÑÑÐ°Ð²Ð»ÑÐµÐ¼ Ð¸ÑÑÐ¾Ð´Ð½ÑÐ¹ ÑÐ°Ð¹Ð».
            resolve(blob && blob.size < file.size ? new File([blob], 'photo.jpg', { type: 'image/jpeg' }) : file);
          },
          'image/jpeg',
          0.85
        );
      } catch (e) {
        URL.revokeObjectURL(url);
        resolve(file);
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(file);
    };
    img.src = url;
  });
};
